function FooterCard({ title, children }) {
  return (
    <div className="bg-primary rounded-lg p-6 flex-1 mx-4 my-4 min-w-[150px] w-full md:w-auto">
      <h4 className="text-textOppPrimary font-semibold mb-4">{title}</h4>
      <div className="text-textOppPrimary">{children}</div>
    </div>
  );
}

export default FooterCard;
